import type { IconData } from '@stacksjs/iconify-core'

export const starF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m10 16.379l-6.173 3.245l1.179-6.874L.01 7.882l6.902-1.003L10 .624l3.087 6.255l6.902 1.003l-4.995 4.868l1.18 6.874z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default starF
